<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">
      <div id="Titulo_div">
        <h1>Historial de Movimientos de Cita</h1>

      </div>
      <div style="display: flex">
        <div class="col-12 padding-div-low">
          <div class="area" v-if="Cita!=null">
            <div class="row">
              <div class="col-4 border-right">
                <div class="row"><h4>Datos del Solicitante</h4></div>
                <div class="row"><b>Nombre: </b><span>{{Cita.InformacionDeSolicitante.NombreCompleto}}</span></div>
                <div class="row"><b>Teléfono: </b><span>{{Cita.InformacionDeSolicitante.Telefono}}</span></div>
                <div class="row"><b>Correo electrónico: </b><span>{{Cita.InformacionDeSolicitante.CorreoElectronico}}</span></div>
                <div class="row"><b>Fecha y hora solicitada: </b><span>{{Cita.AgendaBloque.FechaHoraString}}</span></div>
              </div>
              <div class="col-8">
                <table class="table table-striped table-light table-hover" id="tablaExpedientes">
                  <thead class="thead-dark">
                    <tr class="visible-element">
                      <th>Estatus de la cita</th>
                      <th>Fecha y Hora de cambio</th>
                      <th>Responsable del cambio</th>
                    </tr>
                  </thead>
                  <tbody class='text-dark'>
                    <tr>
                      <td>Creada</td>
                      <td>{{Cita.FechaDeRegistroString}}</td>
                      <td>{{Cita.NombreCuentaCreador}}</td>
                    </tr>
                    <tr v-for="Movimiento in Cita.BitacoraMovimientosDeCita">
                      <td>{{Movimiento.TipoEstatusDeCita.Nombre
                        }}
                      </td>
                      <td>{{Movimiento.FechaDeMovimientoString}}</td>
                      <td>{{Movimiento.NombreCuenta}}</td>

                    </tr>                    
                  </tbody>
                </table>
                
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  export default {
    props: ['citaId'],
    data() {
      return {
        enumeraciones,
        catalogos,
        /*parametros_TiposEstatusDeExpedientes: {
          ValorDefinido: -1,
          TipoEstatusDeExpedienteId: null,
          ConInactivas: false
        },*/
        parametros_TiposEstatusDeExpedientes: [],
        Cita: null,
        NumeroFilasPagina: 10,
        listaExpedientesId: [],
        listaEstatusId: [],
        listaCheckBox: [],
        deshabilitarBotonConfirmar: false,
        estatusGuardados: false,
        textoGenerado: null,
        textoEditable: ""
      }
    },
    components: {
    },
    methods: {
      cargarInfoCita: function () { //Carga la información de BD de una cita.
        var peticion = {
          "esPrueba": false,
          "CitaId": this.citaId
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SICCIJ.funciones.GetCita, peticion, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.Cita = response.data.Cita
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });

      },
      
      volverSeguimientoCitas: function () { //Redirige a la página 'SeguimientoDeCitas'.
        //alert('volver')
        this.$router.push({
          name: 'SeguimientoDeCitas'
        })
        return;
      }
    }, mounted: function mounted() {
      this.cargarInfoCita();
    }, computed: {

    }

  }
</script>

<style scoped>
  .padding-div-low {
    padding-top: 40px;
  }

  .fas {
    cursor: pointer;
  }

  span {
    margin-bottom: 5px;
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Recepcion/SeguimientoDeCitas/HistorialDeMovimientosCita.vue